module.exports = __webpack_public_path__ + "static/img/ukie.f0c1cd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonial/ukie.png
// module id = C1JL
// module chunks = 1